import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {RouteName, routes} from '../../routes';
import {NotFoundPage} from '../../pages/errors/NotFoundPage';
import {DefaultLayout} from "../layouts/DefaultLayout";

export function Routes() {
  const routeNames = Object.keys(routes) as RouteName[];
  const routeWrappers = routeNames.map((name) => {
    const routeOptions = routes[name];
    const Layout = routeOptions.layout as React.FC;
    const Component = routeOptions.component;
    const componentWithLayout = () => (
      <Layout>
        <Component />
      </Layout>
    );

    return (
      <Route
        exact
        sensitive
        path={routeOptions.path}
        component={componentWithLayout}
        key={name}
      />
    );
  });

  return (
    <Switch>
      {routeWrappers}
      <DefaultLayout>
        <Route component={NotFoundPage} />
      </DefaultLayout>
    </Switch>
  );
}
